module.exports = __webpack_public_path__ + "img/Presets Icon_Over.e673d0f6.svg";